import { SignUpResult } from "../../repository/AuthRepository";
export class SignUpUseCaseImpl {
    constructor(authRepository, userRepository) {
        this.authRepository = authRepository;
        this.userRepository = userRepository;
    }
    async run(user, password) {
        const signUpResult = await this.authRepository.signUp(user.email, password);
        if (signUpResult instanceof SignUpResult.Success)
            await this.userRepository.addUser(signUpResult.userId, user);
        return signUpResult;
    }
    isEmailAvailable(email) {
        return this.userRepository.findUserByEmail(email).then(user => !user);
    }
    isUsernameAvailable(username) {
        return this.userRepository.findUserByUsername(username).then(user => !user);
    }
}
